export const formatRows = (data) => { 
  return data.map((item) => ({
    id: item.id,
    user_id: item.user_id,
    cli_name: item.cliente?.cli_name || item.cli_name || "-",
    razon_social: item.cliente?.razon_social || item.cli_razon_social || "-",
    distancia_km: item.distancia_km ? `${item.distancia_km} km` : "-",
    es_principal: item.es_principal === 1 ? "✅ Sí" : "No",
    asignacion: item.asignacion === "auto" ? "🛰️ GPS" : "✋ Manual",
  }));
};

export default formatRows;
